import { render } from "./RouteDescription.vue?vue&type=template&id=845ce772&scoped=true"
import script from "./RouteDescription.vue?vue&type=script&lang=js"
export * from "./RouteDescription.vue?vue&type=script&lang=js"

import "./RouteDescription.vue?vue&type=style&index=0&id=845ce772&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-845ce772"]])

export default __exports__